import Cookies from 'js-cookie';

import { FEATURE_FLAG } from '@/types/featureFlag';
import { FetchCurrentQuery } from 'generated/graphql';

const DOMAIN = process.env.REACT_APP_DOMAIN;

export const setCustomerInfoCookies = (currentData: FetchCurrentQuery) => {
  const tenantSlug = currentData?.current?.tenant?.slug || '';
  const tenantName = currentData?.current?.tenant?.name || '';
  const currentCustomerId = currentData?.current?.customer?.id || '';
  const currentUserId = currentData?.current?.user?.id || '';
  const lat = currentData?.current?.customer?.site?.lat || '';
  const lng = currentData?.current?.customer?.site?.lng || '';
  const pusherChannelName = currentData?.current?.pusherChannelName || '';

  const getSettingValue = (name: string, defaultValue = '') =>
    currentData?.current?.settings?.find((item) => item.name === name)?.value || defaultValue;

  const timezone = getSettingValue('timezone');
  const shouldUseUserTimezone = getSettingValue(FEATURE_FLAG.USE_LOCAL_TIMEZONE_FEATURE, 'false');

  // SET TENANT COOKIES
  Cookies.set('tenant_slug', tenantSlug, {
    domain: DOMAIN,
  });
  Cookies.set('tenant_name', tenantName, {
    domain: DOMAIN,
  });

  Cookies.set('current_customer_id', currentCustomerId, {
    domain: DOMAIN,
  });
  Cookies.set('lat', lat, {
    domain: DOMAIN,
  });

  Cookies.set('long', lng, {
    domain: DOMAIN,
  });
  Cookies.set('pusher_channel_name', pusherChannelName, {
    domain: DOMAIN,
  });
  Cookies.set('current_user_id', currentUserId, {
    domain: DOMAIN,
  });

  Cookies.set('tenant-timezone', timezone);
  Cookies.set('use-local-timezone', shouldUseUserTimezone);

  sessionStorage.setItem('current_customer_id', currentCustomerId);
};
